<template>
  <ModalDialog :show="showModal" @closed="$emit('closed')">
    <div v-if="testResultInfo && student" class="sf-modal-body">
      <MathTestResult
        v-if="subject == 'maths'"
        :test-result-info="testResultInfo"
        :student="student"
      />
      <SpellingTestResult
        v-else
        :test-result-info="testResultInfo"
        :student="student"
      />
    </div>
    <div class="sf-modal-footer">
      <button @click.prevent="showModal = false" class="sf-btn-primary">
        Close
      </button>
    </div>
  </ModalDialog>
</template>

<script lang="ts">
import { SfSubject, SfTestResultInfo, SfUser } from "@/types/generalTypes";
import { defineComponent, PropType } from "vue";
import ModalDialog from "../ui/ModalDialog.vue";
import SpellingTestResult from "./SpellingTestResult.vue";
import MathTestResult from "./MathsTestResult.vue";

export default defineComponent({
  components: { ModalDialog, SpellingTestResult, MathTestResult },
  emits: ["closed"],
  props: {
    subject: { type: String as PropType<SfSubject> },
    student: { type: Object as PropType<SfUser | null> },
    testResultInfo: { type: Object as PropType<SfTestResultInfo | null> },
  },
  data() {
    return {
      showModal: false,
    };
  },
  watch: {
    testResultInfo() {
      if (this.testResultInfo && this.student) {
        this.showModal = true;
      } else {
        this.showModal = false;
      }
    },
    student() {
      if (this.testResultInfo && this.student) {
        this.showModal = true;
      } else {
        this.showModal = false;
      }
    }
  },
});
</script>
